const getters = {
    incomes: state => state.incomes,
    loading: state => state.loading
};

export default getters;